module.exports = __webpack_public_path__ + "img/pic_null.0.1.0_202508261531.png";